import React, { useState } from "react";
import {
  FormControlLabel,
  Grid,
  Link,
  InputAdornment,
  IconButton
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Button from "components/shared/Button/Button";
import {
  StyledCheckbox,
  StyledLoginBox,
  StyledHeader,
  StyledInput
} from "./Login.styles";
import API from "api";
import { useTranslation } from "react-i18next";

interface loginFormInterface {
  email: string;
  password: string;
  type: "provider" | "coordinator" | "patient";
}

interface loginProps {
  target: "provider" | "coordinator" | "patient";
}

export default function Login(props: loginProps) {
  const { t } = useTranslation();
  const [loginForm, setLoginForm] = useState<loginFormInterface>({
    email: "",
    password: "",
    type: props.target
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setLoginForm({ ...loginForm, [event.target.name]: event.target.value });

  const getRoutingDestination = () => {
    if (props.target === "provider") return "/provider/coordinators";
    return "/";
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    API.kore.coordinator
      .login(loginForm)
      .then(({ access }) => {
        if (access === "Provider") {
          API.kore.coordinator.providerAccess(loginForm).then(() => {
            window.location.href = getRoutingDestination();
          });
        } else {
          window.location.href = getRoutingDestination();
        }
      })
      .catch((e) => {
        alert(
          "The user name of password that you have entered does not match our records. Please review your username and password and try again."
        );
      });
  };

  const generatePasswordReset = () => {
    const message = `Would you like to submit a password reset for ${loginForm.email}?`;
    if (window.confirm(message)) {
      const change = {
        email: loginForm.email,
        type: props.target,
        url: `${window.location.protocol}//${window.location.host}`
      };
      API.kore.coordinator.passwordChangeRequest(change).then((reset) => {
        alert("Password reset sent");
      });
    }
  };

  return (
    <Grid container>
      <Grid item xs={1}></Grid>
      <Grid item xs={10}>
        <StyledLoginBox>
          <StyledHeader>
            {props.target.slice(0, 1).toUpperCase()}
            {props.target.slice(1)} {t("u-portal")}
          </StyledHeader>
          <Grid container>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}>
              <form onSubmit={handleSubmit}>
                <StyledInput
                  name="email"
                  placeholder={t("u-email")}
                  size={"small"}
                  value={loginForm.email.toLowerCase()}
                  onChange={handleTextChange}
                />
                <br />
                <StyledInput
                  name="password"
                  placeholder={t("u-password")}
                  size={"small"}
                  type={showPassword ? "text" : "password"}
                  value={loginForm.password}
                  onChange={handleTextChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          onMouseDown={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <br />
                <Link
                  href={"#"}
                  underline={"none"}
                  onClick={generatePasswordReset}
                >
                  {t("s-forgot-password")}
                </Link>
                <br />
                <FormControlLabel
                  control={<StyledCheckbox />}
                  label={t("u-remember-me")}
                />
                <br />
                <Button variant="success" type="submit">
                  {t("u-sign-in")}
                </Button>
              </form>
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>
        </StyledLoginBox>
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
}
